import {NavIconChatIcon} from 'shells/icon/navigation/nav-icon-chat';
import {NavIconDataIcon} from 'shells/icon/navigation/nav-icon-data';
import {NavIconEmailIcon} from 'shells/icon/navigation/nav-icon-email';
import {NavIconEngagementIcon} from 'shells/icon/navigation/nav-icon-engagement';
import {NavIconMarketingIcon} from 'shells/icon/navigation/nav-icon-marketing';
import {ChatbotRegularReportIcon} from 'shells/icon/svg/chatbot-regular-report-icon';
import {SecondarySidebar} from 'shells/navigation/secondary-sidebar/secondary-sidebar';
import type {NavItem} from 'shells/navigation/types';

const NAV_ITEMS: NavItem[] = [
    {
        id: 'email-header',
        label: 'Email Debugging',
        isTopHeader: true,
    },
    {
        id: 'email-debug',
        label: 'Email Debug',
        icon: NavIconEmailIcon,
        to: '/debug/email',
    },
    {
        id: 'email-digest',
        label: 'Email Digest',
        icon: NavIconEmailIcon,
        to: '/debug/email-digest',
    },
    {
        id: 'email-replies',
        label: 'Email Replies',
        icon: NavIconEmailIcon,
        to: '/debug/email-replies',
    },
    {
        id: 'ai-pipelines-header',
        label: 'AI Pipelines',
        isHeader: true,
    },
    {
        id: 'ai2-sandbox',
        label: 'Pipeline v2',
        icon: NavIconEngagementIcon,
        to: '/debug/ai2',
    },
    {
        id: 'ai-sandbox',
        label: 'Pipeline v1',
        icon: NavIconEngagementIcon,
        to: '/debug/ai',
    },
    {
        id: 'summarization-header',
        label: 'AI Summarization',
        isHeader: true,
    },
    {
        id: 'lead-summary',
        label: 'Lead Summary',
        icon: NavIconChatIcon,
        to: '/debug/lead-summary',
    },
    {
        id: 'thread-summary',
        label: 'Thread Summary',
        icon: NavIconChatIcon,
        to: '/debug/thread-summary',
    },
    {
        id: 'task-generation',
        label: 'Task Generation',
        icon: NavIconChatIcon,
        to: '/debug/task-generation',
    },
    {
        id: 'generation-header',
        label: 'Content Generation',
        isHeader: true,
    },
    {
        id: 'marketing-ai',
        label: 'Marketing AI Debug',
        icon: NavIconMarketingIcon,
        to: '/debug/marketing-ai',
    },
    {
        id: 'ai-image-gen',
        label: 'AI Image Gen',
        icon: NavIconMarketingIcon,
        to: '/debug/ai-image-gen',
    },
    {
        id: 'research-header',
        label: 'Research & Data',
        isHeader: true,
    },
    {
        id: 'lead-research',
        label: 'Lead Research',
        icon: NavIconDataIcon,
        to: '/debug/lead-research',
    },
    {
        id: 'enrichment',
        label: 'Enrichment Debug',
        icon: NavIconDataIcon,
        to: '/debug/enrichment',
    },
    {
        id: 'chatbot-report',
        label: 'Chatbot Report',
        icon: ChatbotRegularReportIcon,
        to: '/debug/chatbot-report',
    },
];

export function DebugSidebar(): React.ReactElement {
    return <SecondarySidebar navItems={NAV_ITEMS} />;
}
